import { render, staticRenderFns } from "./BotEdit.vue?vue&type=template&id=3d44de02&"
import script from "./BotEdit.vue?vue&type=script&lang=js&"
export * from "./BotEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports